import { PmsTooltip } from '@/components/ui/pms-tooltip';

interface ToCheckBadgeProps {
  toCheck: boolean;
  reasons: string | null;
}

const FALLBACK_REASON = 'À vérifier — raison non renseignée';

/** Warning badge for words flagged `toCheck`; hover/focus reveals `reasons` (or a generic fallback). */
export function ToCheckBadge({ toCheck, reasons }: ToCheckBadgeProps) {
  if (!toCheck) return null;

  return (
    <PmsTooltip label={reasons?.trim() ? reasons : FALLBACK_REASON} side="right">
      <span className="words-to-check" aria-label="À vérifier">
        <span className="material-symbols-rounded" aria-hidden="true">
          warning
        </span>
      </span>
    </PmsTooltip>
  );
}
